import React, { useCallback } from 'react'
import api from '../../api'
import AsyncSelect from './AsyncSelect'

export default function DeviceModelSelect(props) {
  const fetchOptions = useCallback(async () => {
    const models = await api.deviceModels.list()

    return models.map(deviceModel => ({
      id: deviceModel.id,
      name: `${deviceModel.name} - ${deviceModel.manufacturer}`,
    }))
  }, [])

  return (
    <AsyncSelect
      fetchOptions={fetchOptions}
      showSearch
      optionFilterProp="children"
      placeholder="Select device"
      {...props}
    />
  )
}
